<template>
  <div class="programcommen">
  
    <div class="commenlive">
      <!-- <div  class="zhanwei" >
        <img src="../../assets/noprogram@2x.png" alt="">
      </div> -->
      <div class="live" v-for="(item,index) in commenProgram" :key="index">
       
        <div class="img" @click="nextPage(item)">
          
          <img :src="item.out_image" alt="" class="programImg"  >
          <!-- <img :src="item.category_name" alt="" class="categoryImg"> -->
           <!-- <div class="categoryName">{{item.category_name}}</div> -->
            <div class="show-number">
                 <!-- <p class="beforeTime"> 
                  
                 </p> -->
                 <!-- <div class="show_spectators"> -->
                   <div class="flex">
                     {{item.live_time}}
                    <!-- <img  src="../../assets/heart.png" alt=""  class="liveImg1"  >
                    <font>{{item.star}}</font> -->
                   </div>
                   <div class="flex">
                      <!-- <img  src="../../assets/conversation.png" alt=""  class="liveImg1"  >
                    <font>{{item.show_spectators}}</font> -->
                    <img  src="../../assets/heart.png" alt=""  class="liveImg1"  >
                    <font>{{item.stars_number}}</font>
                   </div>
                 <!-- </div> -->
               </div>
        </div>
         <!-- <figcaption>
            <p class="liveName">
              {{item.title}}
              </p>
            <p class="liveCaption">
              {{item.topic}}
              </p>
            <p class="liveTime">{{item.time | formatDate}}</p>
            
         </figcaption> -->
      </div> 

    </div>
   
  </div>
</template>

<script>
// let baseurl="http://api.dev.cbct.cn/"
import  {formatDate} from '../../../static/js/date.js'
export default {
  name: 'programcommen',
  props: ["commenProgram"],
  data(){
    return { 
     commenProgramData:'',
    //  commonMsg:this.$store.state.commonProgram
    }
  },
  filters: {
    formatDate(time) {
      // time=time.replace("");
      var date = new Date(time*1000);
      return formatDate(date, 'yyyy-MM-dd');
    },
    peopleNumber:function(n1){
        if(n1!="") {
           let strNum="";
         if (n1.length>=5) {
           strNum=(parseFloat(n1/10000).toFixed(1))
         }else{
           strNum=n1
         }
          return strNum     
        }
         
     }
  },
  methods:{
    nextPage:function(item){
      this.$router.push({
        name:'shortVideo',
        query:{
          number:item.number,
          video_id:item.id
        }
      })
    },
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.programcommen{
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  /* padding: 0 0.24rem; */
  /* margin:0 0.3rem 0; */
  /* border: solid 1px; */
  
} 
.commenlive{
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  padding: .2rem;
  /* background: white; */
  box-shadow: 0px .02rem .24rem 0px rgba(29, 31, 33, 0.05);
  border-radius: .16rem;
}
.commenlive .live{
  width: 49%;
  /* height: 3.21rem; */
  /* background: darkgreen; */
  margin-bottom: .1rem;
}
.live .img{
  width: 100%;
  height: 1.68rem;
  /* background: darkgoldenrod; */
  margin: 0;
  position: relative;
}
.live .categoryName{
  position: absolute;
  top: 0.09rem;
  right: 0.09rem;
  width:0.62rem;
  height: 0.3rem;
  /* border: solid 1px; */
  line-height: 0.33rem;
  text-align: center;
  font-size:0.22rem;
  /* font-family:PingFang-SC-Bold; */
  font-weight:400; 
  color:rgba(255,255,255,1);
  background:rgba(80, 191, 255, 1);
  border-radius: 0.05rem;
}
.live .img .programImg{
  width: 100%;
  height: 100%;
}
.show-number{
   position: absolute;
   box-sizing: border-box;
   width: 100%;
   bottom: 0.15rem;
   padding-left: .08rem;
   padding-right: 0.08rem;
   font-size:0.22rem;
   font-weight:bold;
   color:rgba(255,255,255,1);
   text-align: left;
     display: flex;
  justify-content: space-between;
  align-items: center;

}
.liveImg{
  width:0.14rem;
  height:0.17rem;
  margin-right: 0.12rem;
}
.liveImg1{
  width:.16rem;
  height:.14rem;
  margin-right: 0.12rem;
  vertical-align: middle;
}


.live figcaption{
  box-sizing: border-box;
  width: 100%;
  display: inline-block;
  margin-left:0.04rem;
  font-weight:400;
  text-align: left;
  
}

.liveName{
  font-size:0.3rem;
  color:rgba(51,51,51,1);
  width: 100%;
  padding-top:0.16rem;
  white-space:nowrap; 
  overflow:hidden;
  text-overflow:ellipsis;
  font-weight:600;
}
.liveCaption{
  padding: 0.12rem 0 0.1rem;
  font-size:0.26rem;
  color:rgba(102,102,102,1);
  width: 100%;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.liveTime{
  font-size:0.22rem;
  color:rgba(153,153,153,1);
  width: 100%;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  padding-bottom:0.21rem;
}
.zhanwei{
  width:3.24rem;
  margin:0 auto;
  height: 2.6rem;
  margin-top:1rem;
  background: url('../../assets/noprogram@2x.png');
  background-size:100%;
}
.zhanwei img{
  width:3.24rem;
}
.flex{
  display: flex;
  align-items: center;
}
.shopping_img{
  width: 1.64rem;
  height: 1.64rem;
  position: absolute;
  bottom: 1.64rem;
  right: .24rem;
}
/* .show_spectators{
  display: flex;
  justify-content: space-between;
  align-items: center;
} */

</style>
